import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import ReactSelect from 'react-select';
import 'react-select-v1/dist/react-select.css';
import { Entity } from '@debbie/common/dist/index.js';
import { getContactPerson } from '@debbie/common/dist/customers/index.js';
import { Direction, EntityPhoneTags, PhoneIncomingTag, PhoneOutgoingTag, } from '@debbie/common/dist/interactions/index.js';
import { UpdateType } from '@debbie/common/dist/updates/index.js';
import { c, h } from '@debbie/cortex/dist/index.js';
import * as customersAPI from '@debbie/cortex/dist/api/customers.js';
import * as updatesLib from '@debbie/cortex/dist/api/updates.js';
import { selectCaseUpdates } from '@debbie/cortex/dist/case/selectors.js';
import { selectCaseById } from '@debbie/cortex/dist/cases/selectors.js';
import { selectCustomerById } from '@debbie/cortex/dist/customers/selectors.js';
import { selectPhone } from '@debbie/cortex/dist/newInteractions/selectors.js';
import { Button, Textarea, PhoneInput, Select, Checkbox, Badge, Shortcut, Alert, } from '../index.js';
import THEME from '../../theme.js';
import { useCreditor } from '@debbie/cortex/dist/creditors/index.js';
const CallInteraction = (props) => {
    const singleCase = useSelector((s) => selectCaseById(s, props.referenceId));
    const customer = useSelector((s) => singleCase && selectCustomerById(s, singleCase.customerId));
    const phone = useSelector((s) => selectPhone(s, props.referenceId));
    const updates = useSelector((s) => singleCase && selectCaseUpdates(s, singleCase.caseId));
    const lang = useSelector((s) => s.lang);
    const users = useSelector((s) => s.users);
    const creditorId = singleCase?.creditorId ||
        (props.referenceType === Entity.Creditor && props.referenceId);
    const creditorLoadable = useCreditor(creditorId || undefined);
    const creditor = h.hasData(creditorLoadable) ? creditorLoadable.data : null;
    const userRes = creditor && creditor.contactId && users[creditor.contactId];
    const user = userRes && h.isLoaded(userRes) ? userRes.data : null;
    const [visibleToClients, setVisibleToClients] = useState(props.referenceType === Entity.Case);
    const [tags, setTags] = useState([]);
    const [manualPhone, setManualPhone] = useState(null);
    const contactPerson = customer && getContactPerson(customer);
    const _phone = contactPerson &&
        contactPerson.details.phone &&
        contactPerson.details.phone.number
        ? contactPerson.details.phone
        : null;
    const phoneValidation = contactPerson &&
        contactPerson.details.phoneValidations &&
        contactPerson.details.phoneValidations.find((pV) => (pV.phone && pV.phone.number) ==
            (contactPerson.details.phone && contactPerson.details.phone.number) &&
            (pV.phone && pV.phone.locale) ==
                (contactPerson.details.phone && contactPerson.details.phone.locale));
    const getDirection = () => {
        if (!(phone && phone.direction)) {
            return props.outboundMode ? Direction.OUTGOING : Direction.INCOMING;
        }
        else {
            return phone.direction;
        }
    };
    const getManualPhone = () => {
        if (props.referenceType === Entity.Case && !manualPhone && contactPerson) {
            return contactPerson.details.phone || null;
        }
        else if (props.referenceType === Entity.Creditor &&
            !manualPhone &&
            user) {
            return user.phone || null;
        }
        else {
            return manualPhone;
        }
    };
    const secondaryPhones = contactPerson &&
        contactPerson.details.secondaryPhones &&
        contactPerson.details.secondaryPhones.filter((p) => p.enabled);
    const userId = contactPerson?.userId;
    return (React.createElement(React.Fragment, null,
        React.createElement(Select, { value: getDirection(), onChange: (e) => {
                setTags([]);
                c.newInteractions.changeField(props.referenceId, 'phone', 'direction', e.target.value);
            } },
            React.createElement("option", { value: Direction.INCOMING }, lang.interactions[Direction.INCOMING]),
            React.createElement("option", { value: Direction.OUTGOING }, lang.interactions[Direction.OUTGOING])),
        getDirection() === Direction.INCOMING ||
            props.referenceType === Entity.Creditor ? (React.createElement(PhoneInput, { placeholder: lang.interactions.phoneNumber, phone: getManualPhone(), onChange: (e) => {
                setManualPhone(e);
            } })) : (React.createElement("div", null,
            []
                .concat(phoneValidation &&
                phoneValidation.originalCarrier &&
                phoneValidation.originalCarrier.name
                ? {
                    content: phoneValidation.originalCarrier.name,
                }
                : [])
                .concat(phoneValidation &&
                phoneValidation.originalCarrier &&
                phoneValidation.originalCarrier.networkType
                ? {
                    content: lang.phoneValidation[phoneValidation.originalCarrier.networkType] || phoneValidation.originalCarrier.networkType,
                }
                : [])
                .concat(phoneValidation &&
                phoneValidation.roaming &&
                phoneValidation.roaming.status &&
                phoneValidation.roaming.status != 'not_roaming'
                ? {
                    content: lang.phoneValidation[phoneValidation.roaming.status] || phoneValidation.roaming.status,
                }
                : [])
                .concat(phoneValidation &&
                phoneValidation.reachable &&
                !['reachable', 'unknown'].includes(phoneValidation.reachable)
                ? {
                    content: phoneValidation.reachable,
                }
                : [])
                .map((tag) => (React.createElement(Badge, { theme: THEME.COLOR_ACCENT, style: { marginRight: '5px' } }, tag.content))),
            React.createElement("p", null,
                React.createElement("a", { href: `${_phone && _phone.locale ? `tel:+${_phone.locale}` : ''}${_phone && _phone.number ? _phone.number : ''}` },
                    _phone && _phone.locale ? `+${_phone.locale} ` : '',
                    _phone && _phone.number ? _phone.number : ''),
                ' ',
                "(",
                contactPerson && contactPerson.details.name,
                ")"))),
        secondaryPhones && (React.createElement("p", null, secondaryPhones.map(({ phone }, i) => (React.createElement("a", { key: phone.number, href: `${phone && phone.locale ? `tel:+${phone.locale}` : ''}${phone && phone.number ? phone.number : ''}` },
            "+",
            phone.locale,
            " ",
            phone.number,
            i === secondaryPhones.length - 1 ? '' : ', '))))),
        React.createElement(Shortcut, { keys: ['command', 'j'], onPress: (e) => {
                e.preventDefault();
                window.location.href = `${_phone && _phone.locale ? `tel://+${_phone.locale}` : ''}${_phone && _phone.number ? _phone.number : ''}`;
            }, style: {
                left: '5px',
                top: '-38px',
            } }),
        React.createElement(Textarea, { placeholder: lang.interactions.phoneNotes, value: phone.editorState, autoFocus: true, style: { width: '100%', height: '250px', resize: 'vertical' }, onChange: (e) => c.newInteractions.changeEditorState(props.referenceId, 'phone', e.target.value) }),
        React.createElement(ReactSelect, { value: tags.map((tag) => {
                return {
                    label: (getDirection() === Direction.INCOMING
                        ? lang.incomingPhoneCallTags[tag]
                        : lang.outgoingPhoneCallTags[tag]) || tag,
                    value: tag,
                };
            }), isMulti: true, 
            // TODO: Lang
            placeholder: 'Vælg mindst ét tag', options: Object.values(getDirection() === Direction.INCOMING
                ? PhoneIncomingTag
                : PhoneOutgoingTag)
                .filter((tag) => EntityPhoneTags[props.referenceType].includes(tag))
                .map((tag) => ({
                label: (getDirection() === Direction.INCOMING
                    ? lang.incomingPhoneCallTags[tag]
                    : lang.outgoingPhoneCallTags[tag]) || tag,
                value: tag,
            })), onChange: async (tags) => {
                setTags((tags || []).map((tag) => tag.value));
            } }),
        React.createElement("br", null),
        props.referenceType === Entity.Case && (React.createElement(Checkbox, { checked: visibleToClients, onChange: (e) => setVisibleToClients(e.target.checked), placeholder: lang.interactions.visibilityCheckText })),
        userId &&
            tags.find((tag) => [
                PhoneOutgoingTag.IncorrectNumber,
                PhoneOutgoingTag.WrongNumber,
            ].includes(tag)) && React.createElement(Alert, { message: lang.interactions.removingPhoneNumberOnSubmit }),
        React.createElement(Button, { size: "small", loading: phone.loading, disabled: !tags.length, onClick: async () => {
                try {
                    await c.newInteractions.registerPhoneCall(props.referenceId, props.referenceType, {
                        ...phone,
                        direction: getDirection(),
                        tags: tags.map((tag) => ({
                            tag: tag,
                        })),
                        phone: getDirection() === Direction.INCOMING
                            ? getManualPhone()
                            : _phone,
                    }, visibleToClients ? 'client' : 'caseworker');
                    if (userId &&
                        tags.find((tag) => [
                            PhoneOutgoingTag.IncorrectNumber,
                            PhoneOutgoingTag.WrongNumber,
                        ].includes(tag))) {
                        // Delete number
                        if (customer) {
                            await customersAPI.patchUser(customer.customerId, userId, {
                                details: { phone: null },
                            });
                            c.customers.getById(customer.customerId);
                        }
                    }
                    const outboundCallUpdates = updates &&
                        updates.filter((update) => update.updateTypeId === UpdateType.OUTBOUNDCALL);
                    if (props.outboundMode &&
                        getDirection() === Direction.OUTGOING &&
                        outboundCallUpdates &&
                        outboundCallUpdates.length > 0) {
                        for (let i = 0; i < outboundCallUpdates.length; i++) {
                            const update = outboundCallUpdates[i];
                            await updatesLib.patch(update.updateId);
                        }
                        if (singleCase)
                            await c.cases.getUpdates(singleCase.caseId);
                    }
                    setManualPhone(null);
                    setTags([]);
                }
                catch (error) {
                    alert('Error');
                    console.error(error);
                }
            } }, lang.interactions.registerPhoneCall)));
};
export default CallInteraction;
//# sourceMappingURL=CallInteraction.js.map